import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
const InlineTextButton = _ref => {
  let {
    ariaLabel,
    buttonRef,
    children,
    className = '',
    customAttrs,
    disabled,
    id = 'text-button',
    onClick,
    qaId,
    type
  } = _ref;
  const textButtonKeydownHandler = event => {
    if (event.key === ' ') {
      // Activates the anchor button with the space key.
      event.preventDefault();
    } else if (event.key === 'Enter') {
      // If enter is pressed, activate the button
      event.preventDefault();
      activateTextButton();
    }
  };
  const textButtonKeyupHandler = event => {
    if (event.key === ' ') {
      // Activates the anchor button with the space key.
      event.preventDefault();
      activateTextButton();
    }
  };
  const activateTextButton = event => {
    if (onClick && !disabled) {
      onClick(event);
    }
  };
  const classNames = `${className} ${disabled ? 'disabled' : ''}`;
  return /*#__PURE__*/React.createElement("a", _extends({
    "aria-label": ariaLabel,
    className: classNames,
    "data-qa": qaId,
    id: id,
    onClick: activateTextButton,
    onKeyDown: textButtonKeydownHandler,
    onKeyUp: textButtonKeyupHandler,
    ref: buttonRef,
    role: "button",
    tabIndex: 0,
    type: type
  }, customAttrs), children);
};
export default InlineTextButton;